// import React from "react";
// import "../../assets/css/mobNavbar.css";
// import { Col } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import {
//   RiNotificationBadgeFill,
//   RiShieldUserFill,
//   RiShoppingCartFill,
// } from "react-icons/ri";
// import { BsFillCalendarEventFill } from "react-icons/bs";
// import { GrDeliver } from "react-icons/gr";
// import { FaPowerOff } from "react-icons/fa";
// import Profile from "../../assets/img/jj2.jpg";

// export default function MobNavbar() {
//   return (
//     <>
//       <Col className="mobNavbar p-3 d-block d-lg-none">
//         <Col className="text-center">
//           <img
//             src={Profile}
//             alt="sivarm farms prodile"
//             height="auto"
//             width="60%"
//           />
//         </Col>
//         <Col className="mobNavbarMenu mt-4">
//           <ul>
//             <li>
//               <Link to="/notification">
//                 <RiNotificationBadgeFill
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Notifications
//               </Link>
//             </li>
//             <li>
//               <Link to="/userDetails">
//                 <RiShieldUserFill
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Managing Users
//               </Link>
//             </li>
//             <li>
//               <Link to="/productDetails">
//                 <RiShoppingCartFill
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Product List
//               </Link>
//             </li>
//             <li>
//               <Link to="/productOfMonth">
//                 <BsFillCalendarEventFill
//                   className="text-dark me-2"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Product Of The Month
//               </Link>
//             </li>
//             <li>
//               <Link to="/courier">
//                 <GrDeliver
//                   className="text-dark me-2"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Courier
//               </Link>
//             </li>
//             <li>
//               <Link to="/">
//                 <FaPowerOff
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Logout
//               </Link>
//             </li>
//           </ul>
//         </Col>
//       </Col>
//     </>
//   );
// }

import React, { useState } from "react";
import "../../assets/css/mobNavbar.css";
import { Col, Modal, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  RiNotificationBadgeFill,
  RiShieldUserFill,
  RiShoppingCartFill,
} from "react-icons/ri";
import { BsFillCalendarEventFill } from "react-icons/bs";
import { GrDeliver } from "react-icons/gr";
import { FaPowerOff } from "react-icons/fa";
import Profile from "../../assets/jj2.png";

export default function MobNavbar({ handleClose }) {
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    setShowLogout(false);
    if (handleClose) handleClose();
    navigate("/");
  };

  return (
    <>
      <Col className="mobNavbar p-3 d-block d-lg-none">
        <Col className="text-center mb-4">
          <img
            src={Profile}
            alt="chakara arts profile"
            style={{ maxWidth: "200px", width: "80%", height: "auto", borderRadius: "8px" }}
          />
        </Col>
        <Col className="mobNavbarMenu mt-4">
          <ul>
            <li>
              <Link to="/notification" onClick={handleClose}>
                <RiNotificationBadgeFill
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Notifications
              </Link>
            </li>
            <li>
              <Link to="/userDetails" onClick={handleClose}>
                <RiShieldUserFill
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Managing Users
              </Link>
            </li>
            <li>
              <Link to="/productDetails" onClick={handleClose}>
                <RiShoppingCartFill
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Product List
              </Link>
            </li>
            <li>
              <Link to="/productOfMonth" onClick={handleClose}>
                <BsFillCalendarEventFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Product Of The Month
              </Link>
            </li>
            <li>
              <Link to="/courier" onClick={handleClose}>
                <GrDeliver
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Courier
              </Link>
            </li>
            <li>
              <div 
                onClick={() => setShowLogout(true)} 
                style={{ cursor: "pointer", display: "flex", alignItems: "center" }} 
                className="text-dark"
              >
                <FaPowerOff
                  className="text-danger me-2"
                  style={{ fontSize: "1.2em" }}
                />
                Logout
              </div>
            </li>
          </ul>
        </Col>
      </Col>

      {/* Logout Confirmation Modal */}
      <Modal show={showLogout} onHide={() => setShowLogout(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to log out?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLogout(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
